/**
 * @description return agentId if is not === 'all'
 */
export const getAgentId = (agentId?: string): string | undefined => {
  if (!agentId || agentId === 'all') {
    return undefined
  }
  return agentId
}
